import { Box } from '@mui/material';
import React from 'react'

const DialogSubsectionHeadline = ({ marginTop = null, children }) => {

	const style = {
		fontFamily: 'Roboto Bold, Helvetica, sans-serif',
		fontSize: '.875rem',
		fontWeight: 700,
		color: '#2A2D36',
		lineHeight: 'normal',
		marginBottom: '12px',
		marginTop: marginTop ?? '18px',
	}

	return (
		<Box style={style}>{children}</Box>
	)
}

export default DialogSubsectionHeadline;
